import { Link } from 'react-router-dom';
import { Carousel, Image } from 'react-bootstrap';
import Message from './Message';
import { useGetFeaturedArtworksQuery } from '../slices/artworksApiSlice';
import { linkHelpers } from '../utils';

const ArtworksCarousel = () => {
  const { buildArtworkLink } = linkHelpers;
  const { data: artworks, isLoading, error } = useGetFeaturedArtworksQuery();
  return isLoading ? (
    <></>
  ) : error ? (
    <Message variant="danger">{error}</Message>
  ) : (
    <>
    <p className="text-center text-muted mb-1" style={{ fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Featured</p>
    <Carousel pause="hover" variant="dark" className="mb-4" indicators={false}>
      {artworks.map((artwork) => (
        <Carousel.Item key={artwork._id}>
          <Link to={`/artwork/${artwork._id}`}>
            <Image
              className="d-block w-100"
              src={buildArtworkLink(artwork.image)}
              alt={artwork.name}
              fluid
            />
          </Link>
          <div className="text-center mt-2">
            <small className="text-muted">{artwork.name}</small>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
    </>
  );
};

export default ArtworksCarousel;
